import { Directive, Input, SimpleChanges, TemplateRef } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { EditorContainerComponent } from '../../editor-container/editor-container.component';
import { DynamicInputComponent } from '../dynamic-input-model';

@Directive({
  selector: '[editorContentTemplate]'
})
export class EditorContentDirective {
  @Input() menuItems:NbMenuItem[];
  @Input() title:string;
  @Input() menuTag:string;
  @Input() menuGroups:any;
  @Input() inputComponent:DynamicInputComponent;

  constructor(public templateRef: TemplateRef<unknown>,
    public editorContainerComponent:EditorContainerComponent) { 
      
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["title"]){
      
      this.editorContainerComponent.title = this.title;
      this.editorContainerComponent.menuItems = this.menuItems;
      this.editorContainerComponent.menuTag = this.menuTag;
      console.log(this.title);
      console.log(this.inputComponent);
    }
  }
}
